import { BlockType } from 'pn-backend';
import { always } from 'ramda';
import React, { FC } from 'react';

import { BlockProps } from '~types';

export const TestBlock: FC<BlockProps<BlockType.Test>> = always(null);
